import { numberLocale } from './locale';

/** Urlaubstage in der UI-Sprache: halbe Tage als „0,5" (en „0.5"), ganze ohne Nachkommastelle. */
export function formatDays(value: number): string {
  return value.toLocaleString(numberLocale(), { maximumFractionDigits: 1 });
}

/**
 * Tage, die eine Abwesenheit verbraucht: Arbeitstage laut AZM ohne Feiertage. Kalendertage nur,
 * falls der Server (noch) keine Arbeitstage liefert.
 */
export function chargeableDays(absence: { workingDays?: number | null; totalDays?: number | null }): number {
  return absence.workingDays ?? absence.totalDays ?? 0;
}
